<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link
          class="brand-logo"
          :to="{ name: 'home' }"
        >
          <vuexy-logo />
        </b-link>

        <b-card-title class="mb-1">
          Has olvidado tu contraseña? 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Ingrese su correo electrónico y le enviaremos instrucciones
          para restablecer su contraseña
        </b-card-text>
        <!-- form -->
        <validation-observer
          ref="simpleRules"
          #default="{ invalid }"
        >
          <b-form class="auth-forgot-password-form mt-2">
            <b-form-group
              label="* Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="forgot-password-email"
                  placeholder="info@mail.com"
                  autofocus
                />
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>

            <b-button
              v-if="!isLoading"
              type="button"
              variant="primary"
              block
              :disabled="invalid"
              @click="resetPassword"
            >
              Recuperar Contraseña
            </b-button>
            <b-button
              v-if="isLoading"
              variant="primary"
              disabled
              block
            >
              <b-spinner small />
              Loading...
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <p class="text-center mt-2">
            <b-link
              :to="{ name: 'auth-login' }"
              class="text-primary"
            >
              <feather-icon icon="ChevronLeftIcon" />
              Volver al Login
            </b-link>
          </p>
        </b-card-text>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { email, required } from '@validations'
import {
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BForm,
    BFormGroup,
    BFormInput,
    BLink,
    BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
    components: {
        BLink,
        BCard,
        BForm,
        BButton,
        BSpinner,
        BFormGroup,
        BFormInput,
        BCardTitle,
        BCardText,
        ValidationProvider,
        ValidationObserver,
        VuexyLogo,
    },
    data() {
        return {
            userEmail: '',
            required,
            isLoading: false,
            email,
        }
    },
    mounted() {
        this.userEmail =
            this.$route.params.email !== 'undefined'
                ? this.$route.params.email
                : null
    },
    methods: {
        resetPassword() {
            this.isLoading = true
            this.$http
                .post('auth/reset-password', {
                    email: this.userEmail,
                })
                .then(() => {
                    this.isLoading = false
                    this.$swal({
                        title: 'Generado Correctamente',
                        text: 'Contraseña Enviada Correctamente',
                        icon: 'success',
                    })
                })
                .catch((error) => {
                    const err = error.response.data.error
                        ? error.response.data.error
                        : error.message
                    this.isLoading = false
                    this.$swal({
                        title: 'Error',
                        text: err,
                        icon: 'error',
                    })
                })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
